import { connect } from 'react-redux'

import LeadList from '../components/LeadList'
import { listLead, listRefusal } from '../LeadActions'

const mapStateToProps = (state) => {
    return {
    	user: state.user,
    	lead: state.lead.leads,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        listLead: (date ) => {
        	return dispatch(listLead(date))
        },
        listRefusal: () => {
        	return dispatch(listRefusal())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadList)



// WEBPACK FOOTER //
// ./src/lead/containers/LeadListContainer.js